import { render, staticRenderFns } from "./ChecklistView.vue?vue&type=template&id=278dcc2d"
import script from "./ChecklistView.vue?vue&type=script&lang=js"
export * from "./ChecklistView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports